<template>
    <div class="nodata">
        <slot name="img">
            <div class="nodata-img">
                <el-image :src="noDataImg.svg" fit="contain">
                    <div class="placeholder" slot="placeholder"></div>
                    <div slot="error">
                        <el-image :src="noDataImg.png" fit="contain">
                            <div class="placeholder" slot="placeholder"></div>
                            <div slot="error"></div>
                        </el-image>
                    </div>
                </el-image>
            </div>
        </slot>
        <slot name="title">
            <p class="nodata-text">{{title}}</p>
        </slot>
    </div>
</template>

<script>
    const noDataImg = {
        png: require('@/assets/imgs/nodata.png')
    };
    export default {
        name: "NoData",
        props: ["title"],
        data() {
            return {
                noDataImg: noDataImg
            }
        }
    }
</script>

<style scoped lang="scss">
    .nodata {
        min-height: 300px;
        padding: 50px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        line-height: 60px;

        .placeholder {
            width: 40%;
            background: #fff;
        }

        .nodata-img {
            width: 40%;

            img {
                width: 100%;
            }
        }

        .nodata-text {
            color: #b2c8dd;
        }
    }
</style>